import * as DateF from 'date-fns'
import { useMemo } from 'react'

import { DurationFormatter } from '@blade/ui-kit'
import { useFormatDuration } from '@root/shared'
import { useCurrentDate } from '@root/shared/lib/react'

// TODO: It should not be part of pair, but shared
// relevant to https://github.com/Deluge-Cash/deluge-bot/pull/1198

export const usePairAgeFormatted = (createdAt: Date | undefined) => {
  const currentDate = useCurrentDate({ updateInterval: 'second' })

  const { formatDuration } = useFormatDuration()

  const result = useMemo(() => {
    if (!createdAt) {
      return {
        largestDurationUnit: undefined,
        formatted: undefined,
      }
    }

    const duration = DateF.intervalToDuration({
      start: createdAt,
      end: currentDate,
    })

    const largestDurationUnit =
      DurationFormatter.getLargestDurationUnit(duration) ??
      DurationFormatter.Unit.Seconds

    return {
      formatted: formatDuration({
        startAt: createdAt,
        endAt: currentDate,
        mode: 'singleUnitShort',
      }),
      largestDurationUnit,
    }
  }, [createdAt, currentDate, formatDuration])

  return result
}
